import { render, staticRenderFns } from "./AccountBalancesView.vue?vue&type=template&id=dbb36368&scoped=true&"
import script from "./AccountBalancesView.vue?vue&type=script&lang=js&"
export * from "./AccountBalancesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb36368",
  null
  
)

export default component.exports